module.exports = __webpack_public_path__ + "static/media/unibes.969462a9.png";